// extracted by mini-css-extract-plugin
var _1 = "MarkdownCell_markdown__mYcoe";
var _2 = "MarkdownCell_markdownWrapper__sCvyf";
export { _1 as "markdown", _2 as "markdownWrapper" }
